export class CABA1020RequestModel {}
